import janooService from "@/services/janoo/index"
import cakeService from "@/services/cakephp/index";
import nodeService from "@/services/nodejs/index"

async function fetchPOIs(state, payload) {
  state.commit("RESET_POIS")
  await nodeService.getPoisByVendor(payload)
    .then((res) => {
      var response = res.data
      state.commit("SET_POIS", response)
    })
}

async function loadProducts(state) {
  const response = await cakeService.getProdutos()
  state.commit("SET_PRODUCTS", response.list)
  return response
}

async function loadProductsMap(state) {
  const response = await cakeService.getFieldsMap('products')
  state.commit("SET_PRODUCTS_MAP", response.map)
  return response
}

const productStoreCommit = (state, payload) => {
  state.commit(payload.mutation, payload.value)
}

function resetChartsCache(state) {
  state.commit('RESET_BAR_CHART_ARRECADACAO')
  state.commit('RESET_BAR_CHART_PRODUTIVIDADE')
  state.commit('RESET_BAR_CHART_HORARIO')
  state.commit('RESET_BAR_CHART_VISITANTES')
  state.commit('RESET_BAR_CHART_TAMANHO')
  state.commit('RESET_DOUGHNUT_CHART_ATRATIVO')
  state.commit('RESET_FILTERED_BILL_ITENS_AMOUNT')
  state.commit('RESET_YESTERDAY_TOTAL_CLIENTS')
  state.commit('RESET_TOMORROW_TOTAL_CLIENTS')
  state.commit('RESET_TODAY_TOTAL_CLIENTS')
  state.commit('RESET_CACHE_LIMIT_DATE')
}

export default {
  fetchPOIs,
  loadProducts,
  loadProductsMap,
  resetChartsCache,
  productStoreCommit,
}
